// src/Dashboard/pages/user/TechniquesQuizzDashboard/components/TechniquesGameModeTabs.jsx
// Adapte le chemin si besoin.

import React from "react";
import { FaBrain, FaImages } from "react-icons/fa";

const MODES = [
  {
    value: "quizz",
    label: "Quizz",
    title: "Trouver la technique",
    description: "Une image, quatre réponses.",
    icon: FaBrain,
  },
  {
    value: "memory",
    label: "Jeu des familles",
    title: "Retrouver les paires",
    description: "Retournez deux cartes identiques.",
    icon: FaImages,
  },
];

export default function TechniquesGameModeTabs({
  value,
  onChange,
  quizzStats,
  memoryStats,
}) {
  return (
    <section className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      {MODES.map((mode) => {
        const Icon = mode.icon;
        const selected = value === mode.value;

        const statLabel =
          mode.value === "quizz"
            ? `${quizzStats?.totalQuestions || 0} questions`
            : `${memoryStats?.totalCards || 0} cartes`;

        return (
          <button
            key={mode.value}
            type="button"
            onClick={() => onChange(mode.value)}
            className={`group overflow-hidden rounded-[24px] border p-4 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md active:scale-[0.99] ${
              selected
                ? "border-[#013E8E]/30 bg-[#013E8E] text-white ring-2 ring-[#013E8E]/20"
                : "border-slate-200 bg-white text-slate-900 hover:bg-slate-50 dark:border-slate-800 dark:bg-slate-900 dark:text-white dark:hover:bg-slate-800"
            }`}
          >
            <div className="flex items-center gap-4">
              <span
                className={`grid h-14 w-14 shrink-0 place-items-center rounded-2xl text-xl ring-1 transition ${
                  selected
                    ? "bg-white/15 text-white ring-white/20"
                    : "bg-indigo-50 text-[#013E8E] ring-indigo-100 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20"
                }`}
              >
                <Icon />
              </span>

              <span className="min-w-0 flex-1">
                <span
                  className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.16em] ${
                    selected
                      ? "bg-white/15 text-white"
                      : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300"
                  }`}
                >
                  {mode.label}
                </span>

                <span className="mt-2 block text-lg font-bold">
                  {mode.title}
                </span>

                <span
                  className={`mt-1 block text-sm ${
                    selected
                      ? "text-white/80"
                      : "text-slate-500 dark:text-slate-400"
                  }`}
                >
                  {mode.description}
                </span>
              </span>

              <span
                className={`hidden rounded-2xl px-3 py-2 text-sm font-bold sm:inline-flex ${
                  selected
                    ? "bg-white/15 text-white ring-1 ring-white/20"
                    : "bg-slate-50 text-slate-600 ring-1 ring-slate-200 dark:bg-slate-950 dark:text-slate-300 dark:ring-slate-700"
                }`}
              >
                {statLabel}
              </span>
            </div>
          </button>
        );
      })}
    </section>
  );
}